import { Navigate } from "react-router-dom";
import PrivateRoute from "./components/privateroute/PrivateRoute";

import FAQ from "./pages/Faq";
import Invite from "./pages/Invite";
import Splash from "./pages/Splash";
import Slider from "./pages/Slider";
import Policy from "./pages/Policy";
import Setting from "./pages/Setting";
import Support from "./pages/Support";

import Login from "./pages/Login";
import LoginVerify from "./pages/LoginVerify";

import PiecesLong from "./pages/PiecesLong";
import PiecesMid from "./pages/PiecesMid";
import PiecesShort from "./pages/PiecesShort";
import PieceDetails from "./pages/PiecesDetails";

import UserCars from "./pages/UserCars";
import UserProfile from "./pages/UserProfile";
import UserSetCar from "./pages/UserSetCar";
import UserSetInfo from "./pages/UserSetInfo";
import UserCarDetails from "./pages/UserCarDetails";
import ServicePlace from "./pages/ServicePlace";
import SetServicePlaceDetails from "./pages/SetServicePlaceDetails";
import CurrentServicePlace from "./pages/CurrentServicePlace";
import InsuranceList from "./pages/InsuranceList";
import PayEst from "./pages/PayEst";
import Violation from "./pages/Violation";
import ViolationInquiryResult from "./pages/ViolationInquiryResult";
import PayBill from "./pages/PayBill";

let routes = [
  {
    path: "/",
    element: <Splash />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/verify",
    element: <LoginVerify />,
  },
  { path: "/faq", element: <FAQ /> },
  { path: "/slider", element: <Slider /> },
  { path: "/policy", element: <Policy /> },
  { path: "/invite", element: <Invite /> },
  { path: "/contactus", element: <Support /> },
  { path: "/setting", element: <Setting /> },
  { path: "/servicePlace", element: <ServicePlace /> },
  { path: "/setServicePlaceDetails", element: <SetServicePlaceDetails /> },
  { path: "/currentServicePlace", element: <CurrentServicePlace /> },
  { path: "/insuranceList", element: <InsuranceList /> },
  { path: "/payEst", element: <PayEst /> },
  { path: "/violation", element: <Violation /> },
  { path: "/violation-inquiry-result", element: <ViolationInquiryResult /> },
  { path: "/payBill", element: <PayBill /> },
  {
    path: "/profile",
    element: (
      <PrivateRoute>
        <UserProfile />
      </PrivateRoute>
    ),
  },
  {
    path: "/add-car",
    element: (
      <PrivateRoute>
        <UserCars />
      </PrivateRoute>
    ),
  },
  {
    path: "/car-details",
    element: (
      <PrivateRoute>
        <UserCarDetails />
      </PrivateRoute>
    ),
  },
  {
    path: "/add-car-details",
    element: (
      <PrivateRoute>
        <UserSetCar />
      </PrivateRoute>
    ),
  },
  {
    path: "/driver-info",
    element: <UserSetInfo />,
  },

  {
    path: "/short-terms",
    element: (
      <PrivateRoute>
        <PiecesShort />
      </PrivateRoute>
    ),
  },
  {
    path: "/mid-terms",
    element: (
      <PrivateRoute>
        <PiecesMid />
      </PrivateRoute>
    ),
  },
  {
    path: "/long-terms",
    element: (
      <PrivateRoute>
        <PiecesLong />
      </PrivateRoute>
    ),
  },
  {
    path: "/piece-details/:data",
    element: (
      <PrivateRoute>
        <PieceDetails />
      </PrivateRoute>
    ),
  },

  // ------------------- 404 Code ------------------- //
  {
    path: "*",
    element: <Navigate to="/add-car" />,
  },
];

export default routes;
